<template>
  <div class="container">
      <!-- ////////////// Header Start ////////////// -->
      <app-header></app-header>
      <!-- ////////////// Header End ////////////// -->
      <div style="padding-top: 150px;"></div>
      <div class="arrow"></div>
      <div class="h2-arrow">CONDITIONS D’UTILISATION DU SITE</div>
      <div class="h3-sub-title">Préambule</div>
      <p class="col-md-12 columns">Le présent site, entièrement géré par Orisha Adgency, est un site de dépôt et de mise en ligne de messages dans lʼespace dédié aux commerçants du programme Orisha Adgency. Les messages doivent être de type informatif concernant votre commerce (horaires, congés, menu du jour...) ou dʼauto-promotion (services et ou produits disponibles, promotions et soldes...). Lʼutilisation de lʼespace commerçant dans le programme Orisha Adgency est gratuite et exclusivement réservée aux clients Orisha Commerce. Cet espace ne peut être commercialisé ni cédé à un tiers. Le seul fait dʼutiliser le présent site implique lʼacceptation pleine et entière des conditions dʼutilisation décrites ci-dessous.</p>
      <div class="h3-sub-title">Contenu des messages diffusés dans l’espace commerçant</div>
      <p class="col-md-12">
        Nous vous remercions de respecter le règlement sur le contenu décrit ci-dessous.<br/><br/>
        <strong>Règlement sur les contenus interdits</strong><br/>
        Afin de maintenir un service de qualité, il est interdit de diffuser un message :<br/>
        <span style="display: block; padding-left: 15px;">
        - qui contient des informations personnelles concernant un individu ne souhaitant pas qu'elles apparaissent<br/>
        - qui soit mensonger*, diffamatoire, profane, haineux, abusif, pornographique, obscène ou de toute autre nature inappropriée (et laissé à notre seule discrétion)<br/>
        - qui encourage la violence ou toute conduite criminelle<br/>
        - qui dévoile des éléments de nature privée ou viole la vie privée d'une personne (inclus la publication de visages) sans son autorisation<br/>
        - qui contrevienne aux droits de propriété physique ou intellectuelle d'un tiers<br/>
        - qui propose de l'information, des produits ou des services dont la vente, la distribution ou la divulgation est sujette à régulations** ou dont la possession ou vente est illégale. Vous ne pouvez diffuser un message dont le but est de vendre des objets contrefaits, de la drogue (interdite ou sur ordonnance), tout type de médicaments, des armes à feu sans permis ou armes blanches, des organes ou parties de corps humain, des billets de loterie, du tabac, de l'alcool ou tout type de produit dangereux.<br/>
        - faisant la promotion de groupes à caractère sectaire.</span><br/><br/>
        <span style="color: var(--primary-color); font-weight: bold; font-style: italic;">Attention :</span><br/>
        * Veillez à ce que les termes que vous utilisez pour communiquer à propos dʼun produit soient bien exacts. Par exemple, vous ne pouvez pas parler de carte de crédit à propos de PCS Card car il sʼagit en réalité dʼune carte de paiement, vous seriez exposé à des poursuites pour publicité mensongère.<br/>
        ** La Loi Evin et la loi Santé qui régissent la publicité concernant l'alcool, le tabac, l'alimentation sont très contraignantes et restrictives.
      </p>
      <p class="col-md-12">
        Nous rappelons que l'ensemble des agissements susvisés constituent des infractions définies et réprimées par le code pénal français, dont la violation pourrait vous engager à des poursuites ou sanctions judiciaires, l'Equipe Orisha Adgency ne pouvant être tenue responsable du contenu de vos messages. Vous êtes responsables de vous assurer de respecter la loi qui s'applique aux biens et services que vous offrez.
      </p>
      <p class="col-md-12">
        Cette liste est non exhaustive et Orisha Adgency se réserve le droit dʼarrêter la diffusion de tout message non conforme.
      </p>
      <p class="col-md-12">
        <em><span style="color: var(--fourth-color); font-weight: bold;">Information sur lʼutilisation des logos :</span> Nous vous rappelons quʼil ne vous est pas possible de faire la promotion de produits en faisant figurer les logos des marques car leur utilisation est soumise à une réglementation stricte.</em>
      </p>
      <p class="col-md-12">
        Dans le cas où un utilisateur réitère la diffusion de messages non conformes, Orisha Adgency se réserve le droit de lui interdire lʼaccès au site.
      </p>
      <div class="h3-sub-title">Responsabilité</div>
      <p class="col-md-12">
        Orisha Adgency se réserve le droit d'interrompre l'accès au site pour procéder à des opérations de maintenance et/ou de test. Orisha Adgency s'efforcera de réaliser ces opérations pour les durées les plus courtes possible et en dehors des heures de forte utilisation. La responsabilité de Orisha Adgency ne pourra en aucun cas être recherchée de ce fait.
      </p>
      <div class="h3-sub-title">Durée de diffusion</div>
      <p class="col-md-12">
        Vous seul gérez la durée de diffusion de vos messages, vous pouvez les actualiser aussi souvent et aussi fréquemment que vous le souhaitez.
      </p>
      <p class="col-md-12">DIGITAL POINT DE VENTE - Orisha Adgency – SARL au capital de 12 000€ - RCS Paris 500 248 141<br/>
      T : 01 53 09 26 80 – www.retail-shops.orisha.com/adgency</p>
      <div style="padding-top: 750px;"></div>
    <!-- ////////////// Footer Start ////////////// -->
    <app-footer></app-footer>
    <!-- ////////////// Footer End ////////////// -->
  </div>
</template>

<script>
  import Header from '@/components/Header'
  import Footer from '@/components/Footer'
  export default {
    name: 'conditions-utilisation',
    data () {
      return {
        msg: 'Conditions d\'Utilisation'
      }
    },
    components: {
      'app-header': Header,
      'app-footer': Footer
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  p {
    text-align: justify;
    padding-bottom: 25px;
  }

  .container {
    text-align: left;
    padding-bottom: 100px;
  }

  .columns {
      text-align: justify;
      -webkit-column-count: 2; /* Chrome, Safari, Opera */
      -moz-column-count: 2; /* Firefox */
      column-count: 2;
      -webkit-column-gap: 40px; /* Chrome, Safari, Opera */
      -moz-column-gap: 40px; /* Firefox */
      column-gap: 40px;
  }

</style>



// WEBPACK FOOTER //
// ConditionsUtilisation.vue?797835c4